import React from 'react';
export const FontSizeIcon = (props) => (
<svg
    className="svg-icon"
    style={{
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden",
    }}
    viewBox="0 0 1024 1024"
    id="svg287"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <defs id="defs291">
      <rect
        x={138.84746}
        y={108.47458}
        width={880.81356}
        height={685.55932}
        id="rect305"
      />
      <rect
        x={138.84746}
        y={108.47458}
        width={880.81354}
        height={685.55933}
        id="rect305-1"
      />
    </defs>
    <text
      xmlSpace="preserve"
      id="text303"
      style={{
        fontStyle: "normal",
        fontVariant: "normal",
        fontWeight: "bold",
        fontStretch: "normal",
        fontSize: 192,
        lineHeight: 1.25,
        fontFamily: "Arial",
        letterSpacing: 0,
        wordSpacing: 0,
        whiteSpace: "pre",
        shapeInside: "url(#rect305)",
        display: "inline",
      }}
      transform="matrix(4.5512777,0,0,5.1357474,-600.75911,-645.37132)"
    >
      <tspan x={138.84766} y={281.41946} id="tspan10706">
        {"A"}
      </tspan>
    </text>
    <text
      xmlSpace="preserve"
      id="text303-4"
      style={{
        fontStyle: "normal",
        fontVariant: "normal",
        fontWeight: "bold",
        fontStretch: "normal",
        fontSize: 192,
        lineHeight: 1.25,
        fontFamily: "Arial",
        letterSpacing: 0,
        wordSpacing: 0,
        whiteSpace: "pre",
        shapeInside: "url(#rect305-1)",
        display: "inline",
        overflow: "hidden",
        fill: "currentColor",
      }}
      transform="matrix(3.0990433,0,0,3.3169817,137.47798,-133.55693)"
    >
      <tspan x={138.84766} y={281.41946} id="tspan10708">
        {"A"}
      </tspan>
    </text>
  </svg>
);
